export const TypeText = ({ item, index, handleChange, changeData, label }) => {
  return (
    <div className="flex mt-2">
      <div className="flex flex-col">
        <label className="mb-1 mt-2 paragraphs_font text-xs">
          {label ? label : "Field Label"}{" "}
          <span className="text-red-500"> *</span>
        </label>
        <input
          type="text"
          value={item?.label}
          name="label"
          className="tabs-input-border px-2 py-1 rounded paragraphs_font text-sm"
          onChange={(e) => {
            handleChange(index, e);
          }}
          onBlur={() => {
            changeData();
          }}
        />
      </div>
      {item.fieldType !== "date" &&
        item.fieldType !== "rating" &&
        item.fieldType !== "disclaimer" && (
          <div className="flex flex-col ml-3">
            <label className="mb-1 mt-2 paragraphs_font text-xs">
              Field PlaceHolder <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              value={item?.placeHolder}
              name="placeHolder"
              className="tabs-input-border px-2 py-1 rounded paragraphs_font text-sm"
              onChange={(e) => {
                handleChange(index, e);
              }}
              onBlur={() => {
                changeData();
              }}
            />
          </div>
        )}
    </div>
  );
};

export const TypeTextValidations = ({
  item,
  index,
  handleChange,
  changeData,
  errorMessages = {},
  setErrorMessages,
}) => {
  return (
    <div className=" pt-4">
      <div className="flex">
        <div class="wrapper w-11">
          <div class="switch_box box_1 ">
            <input
              type="checkbox"
              class="switch_11"
              name="isRequired"
              checked={item?.isRequired}
              onChange={(e) => {
                handleChange(index, e);
              }}
            />
          </div>
        </div>
        <label className="margin-label paragraphs_font text-sm">
          {item?.isRequired ? "Required" : "Not Required"}
        </label>
      </div>
      <div className="flex">
        <div class="wrapper w-11">
          <div class="switch_box box_1 ">
            <input
              type="checkbox"
              class="switch_11"
              name="isDisabled"
              checked={item?.isDisabled}
              onChange={(e) => {
                handleChange(index, e);
              }}
            />
          </div>
        </div>
        <label className="margin-label paragraphs_font text-sm">
          {!item?.isDisabled ? "Editable" : "Not Editable"}
        </label>
      </div>
      <div className="flex flex-row">
        <div className="flex flex-col pt-4 w-2/5">
          <label className="mb-1 mt-2 paragraphs_font">
            Mininum Character Limit
          </label>
          <input
            type="number"
            value={
              item.fieldType === "date" ||
              item.fieldType === "select" ||
              item.fieldType === "rating" ||
              item.fieldType === "barCode" ||
              item.fieldType === "checkBox" ||
              item.fieldType === "radio"
                ? "0"
                : item?.minLength
            }
            disabled={
              item.fieldType === "date" ||
              item.fieldType === "select" ||
              item.fieldType === "rating" ||
              item.fieldType === "barCode" ||
              item.fieldType === "checkBox" ||
              item.fieldType === "radio"
                ? true
                : false
            }
            name="minLength"
            minlength="4"
            className="tabs-input-border px-2 py-1 rounded paragraphs_font text-sm"
            onChange={(e) => {
              if (e.target.value.length <= 3 && e.target.value <= 150) {
                handleChange(index, e);
              } else {
                e.target.value = "";
              }
            }}
            onBlur={() => {
              changeData();
            }}
          />
        </div>
        <div className="flex flex-col pt-4 w-2/5">
          <label className="mb-1 mt-2 paragraphs_font">
            Maximum Character Limit
          </label>
          <input
            type="number"
            value={
              item.fieldType === "date" ||
              item.fieldType === "select" ||
              item.fieldType === "rating" ||
              item.fieldType === "barCode" ||
              item.fieldType === "checkBox" ||
              item.fieldType === "radio"
                ? "0"
                : item?.maxLength
            }
            disabled={
              item.fieldType === "date" ||
              item.fieldType === "select" ||
              item.fieldType === "rating" ||
              item.fieldType === "barCode" ||
              item.fieldType === "checkBox" ||
              item.fieldType === "radio"
                ? true
                : false
            }
            name="maxLength"
            min="1"
            max="150"
            className="tabs-input-border px-2 py-1 rounded paragraphs_font text-sm"
            onChange={(e) => {
              // Always allow typing and updating
              handleChange(index, e);
            }}
            onBlur={(e) => {
              const value = parseInt(e.target.value);
              const minLength = parseInt(item?.minLength) || 1;

              // Clear any existing error
              if (setErrorMessages) {
                setErrorMessages((prev) => {
                  const newErrors = { ...prev };
                  delete newErrors[`maxLength_${index}`];
                  return newErrors;
                });
              }

              // Validate on blur and show feedback
              if (value < minLength) {
                if (setErrorMessages) {
                  setErrorMessages((prev) => ({
                    ...prev,
                    [`maxLength_${index}`]: `Maximum character limit must be at least ${minLength} (minimum character limit)`,
                  }));
                }
                // Clear the field by updating the state
                const updatedEvent = {
                  ...e,
                  target: {
                    ...e.target,
                    name: "maxLength",
                    value: "",
                  },
                };
                handleChange(index, updatedEvent);
              } else if (value > 150) {
                if (setErrorMessages) {
                  setErrorMessages((prev) => ({
                    ...prev,
                    [`maxLength_${index}`]:
                      "Maximum character limit cannot exceed 150",
                  }));
                }
                // Clear the field by updating the state
                const updatedEvent = {
                  ...e,
                  target: {
                    ...e.target,
                    name: "maxLength",
                    value: "",
                  },
                };
                handleChange(index, updatedEvent);
              }

              changeData();
            }}
          />
          {errorMessages[`maxLength_${index}`] && (
            <p className="text-red-500 text-xs mt-1">
              {errorMessages[`maxLength_${index}`]}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};
